export function getTouristCardRedirectUrl(href: string, baseUrl = window.location.href): string | null {
    try {
        const url = new URL(href, baseUrl);
        const host = url.hostname.toLowerCase();
        if ((url.protocol !== "http:" && url.protocol !== "https:") ||
            (host !== "getyourguide.com" && !host.endsWith(".getyourguide.com"))) {
            return null;
        }

        url.searchParams.set("cmp", "destination-tourist-card");
        return url.href;
    } catch {
        return null;
    }
}
